/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState, Fragment } from "react";
import { find } from "lodash";
import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import SearchIcon from "@mui/icons-material/Search";
import { ComponentUsageColumn } from "./component-usage-column";
import { ComponentFilters } from "../filters/component-filters";
import { Logger } from "cms/utils/log/logger";
// import { ComponentPreviewColumn } from './component-preview-column'

const DataGridSelector = (props) => {
    
    const {
        applySortModel,
        applyTextSearch,
        changePage,
        changePageSize,
        currentPageSize,
        filteredComponents,
        showTree,
        treeVisible,
        isLoading,
        rowCount,
        setSelectedComponent,
        columnDefinitions
    } = props;
    
    const [searchText, setSearchText] = useState("");
    const [columns, setColumns] = useState();
    
    // set up columns using functions that return components
    useEffect(() => {
        const cols = columnDefinitions.map((def) => {
            if (def.field === "timesUsed") {
                def.renderCell = usageColumnFn;
            }
            if (def.field === "component") {
                def.renderCell = viewColumnFn;
            }
            return def;
        });
        setColumns(cols);
        // eslint-disable-next-line
    }, [columnDefinitions])
    
    // run API search when the search text changes
    useEffect(() => {
        const delayedSave = setTimeout(() => {
            Logger.debug(searchText);
            applyTextSearch(searchText);
        }, 300);
        return () => {
            clearTimeout(delayedSave);
        };
        // eslint-disable-next-line
    }, [searchText])
    
    const onChangeSearchText = (event) => {
        const text = event.target.value;
        setSearchText(text);
    };
    const onPageChange = (page) => {
        changePage(page);
    };
    const onPageSizeChange = (size) => {
        changePageSize(size);
    };
    const onSortModelChange = (model) => {
        applySortModel(model);
    };
    const onSelectionModelChange = (ids) => {
        const selectedComponent = find(filteredComponents, { id: ids[0] });
        setSelectedComponent(selectedComponent);
    };
    
    const usageColumnFn = (params) => {
        try {
            return <ComponentUsageColumn params={params} />;
        } catch (error) {
            Logger.error(error);
            return <></>;
        }
    };
    
    // eslint-disable-next-line
    const viewColumnFn = (params) => {
        
        return <Fragment />;
        // try {
        //     return <ComponentPreviewColumn params={params} />
        // } catch (error) {
        //     Logger.error(error)
        //     return <></>
        // }
    };

    return (
        <>
            <Grid direction='row' gap={1} container>
                
                {/*  Browse Webpages Filter */}
                {!treeVisible &&
                    <Button
                        variant='outlined'
                        color='neutral'
                        size='small'
                        startIcon={<AccountTreeIcon />}
                        onClick={showTree}
                    >
                        Browse by webpage
                    </Button>
                }
                
                <ComponentFilters />
                
                {/*  Search Bar For Grid */}
                <TextField
                    size='small'
                    value={searchText}
                    onChange={onChangeSearchText}
                    className='searchTextFieldStyle'
                    placeholder='Search by label or content  sample'
                    type='search'
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position='start'>
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />
                
            </Grid>
            
            <div className='dataGridContainerStyle'>
                <div style={{ flexGrow: 1 }}>
                    {columns &&
                        <DataGrid
                            rows={filteredComponents}
                            rowCount={rowCount}
                            className='dataGrid'
                            pageSize={currentPageSize}
                            density='compact'
                            filterMode='server'
                            paginationMode='server'
                            sortingMode='server'
                            loading={isLoading}
                            disableColumnMenu={true}
                            rowsPerPageOptions={[5, 10, 20]}
                            columns={columns}
                            onPageChange={onPageChange}
                            onPageSizeChange={onPageSizeChange}
                            onSortModelChange={onSortModelChange}
                            onSelectionModelChange={onSelectionModelChange}
                        />
                    }
                </div>
            </div>
        </>
    );
};

export { DataGridSelector };
